Ext.define('SA.model.LocationValue.Item', {
    extend: 'SA.model.LocationValue',

    statics: {
        isConformantValue(value) {
            var object = SA.Object.of(value);

            return object
                && object.keysAre(['type', 'id'])
                && object.hasType(['locationSeries', 'customLocation']);
        }
    },

    getId() {
        return this.value.id;
    },

    toItem() {
        return this.value;
    },

    toString() {
        if (this.value.type === 'locationSeries') {
            return this.getId();
        }

        return this.callParent();
    }
});